import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { RiskyPregnancyCertificate } from '@app/entities/models/ptrab/certificates/risky-pregnancy.model';

export interface CertificatesRepository {
  getRiskyPregnancyList(): Observable<RiskyPregnancyCertificate[]>;
}

export const CERTIFICATES_REPOSITORY = new InjectionToken<CertificatesRepository>('CERTIFICATES_REPOSITORY');
